<template>
  <div class="userTagMarkdownEditor">
    <Mentionable :keys="['@']" :items="tagDict" offset="6">
      <v-textarea
        ref="textarea"
        :label="label"
        type="text"
        rows="3"
        no-details
        outlined
        hide-details
        :value="value"
        @input="onTextareaUpdate"
        append-outer-icon="mdi-send"
        @click:append-outer="$emit('submit')"
        @keydown.enter="() => sendOnEnter && $emit('submit')"
        :disabled="disabled"
      />
      <template #no-result>
        <div class="dim">{{ $t("components.mentionInput.noResult") }}</div>
      </template>

      <template #item-@="{ item }">
        <div class="user">
          {{ item.name }}
          <span class="dim"> ({{ item.identifier }}) </span>
        </div>
      </template>
    </Mentionable>
  </div>
</template>

<script>
import { Mentionable } from "vue-mention";

export default {
  name: "user-tag-v-textarea",
  components: {
    Mentionable,
  },
  props: {
    label: String,
    value: String,
    disabled: Boolean,
    users: Array,
    groups: Array,
    sendOnEnter: Boolean,
  },
  methods: {
    onTextareaUpdate(newVal) {
      this.$emit("input", newVal);
    },
  },
  computed: {
    tagDict() {
      return [
        ...this.users
        ? this.users.map((user) => ({
            ...user,
            identifier: user.email,
            value: user.name.replaceAll(" ", "") + "[" + user.email + "]",
          }))
        : [],
        ...this.groups
        ? this.groups.map((group) => ({
            ...group,
            identifier: "group:" + group.name,
            value: group.name.replaceAll(" ", "") + "[group:" + group.name + "]",
          }))
        : []
      ].sort((a, b) => a.name.localeCompare(b.name))
    },
  },
};
</script>

<style scoped></style>
